import { forwardRef } from 'react'
import {
  rucksack,
  Box,
  LinearProgress,
  Typography,
} from '@black-bear-energy/rucksack'

export const LabeledProgressBar = forwardRef<
  HTMLDivElement,
  LabeledProgressBarProps
>(({ numerator, denominator, ...props }: LabeledProgressBarProps, ref) => {
  const value = (numerator / denominator) * 100
  let color: 'success' | 'warning' | 'error' = 'warning'
  if (numerator === denominator) {
    color = 'success'
  } else if (numerator === 0) {
    color = 'error'
  }

  return (
    <Box
      ref={ref}
      {...props}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 1,
        paddingX: 1,
      }}
    >
      <LinearProgress
        value={value}
        variant="determinate"
        color={color}
        sx={{
          width: '100%',
          borderRadius: rucksack.shape.borderRadius,
        }}
      />
      <Typography variant="body2">
        {numerator} / {denominator}
      </Typography>
    </Box>
  )
})

LabeledProgressBar.displayName = 'LabeledProgressBar'

export interface LabeledProgressBarProps {
  numerator: number
  denominator: number
}
